import React from 'react';
import { motion } from 'framer-motion';
import { RotateCcw } from 'lucide-react';

const RefundPolicy = () => {
  return (
    <div className="pt-20" data-testid="refund-page">
      {/* Hero Section */}
      <section className="py-16 md:py-20 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <RotateCcw className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold">
              Donation Refund Policy
            </h1>
            <p className="mt-4 text-slate-300">Lane 4 For All Kids Foundation</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate prose-lg">
          <p className="text-slate-600"><strong>Effective Date:</strong> January 2026</p>

          <p>Lane 4 For All Kids Foundation appreciates the generosity of our supporters and understands that errors may occasionally occur when making online donations.</p>

          <h2 className="font-heading">Refund Requests</h2>
          <p>Refund requests for donations may be considered under the following circumstances:</p>
          <ul>
            <li>A duplicate donation was made</li>
            <li>An incorrect donation amount was entered</li>
            <li>The donation was made in error</li>
          </ul>

          <p>To request a refund, please contact us within <strong>15 days</strong> of the donation date.</p>

          <p>Refund requests should include:</p>
          <ul>
            <li>Donor name</li>
            <li>Donation date</li>
            <li>Donation amount</li>
            <li>Transaction confirmation information (if available)</li>
          </ul>

          <h2 className="font-heading">Processing Refunds</h2>
          <p>Approved refunds will be issued using the <strong>original payment method</strong> whenever possible. Processing time may vary depending on the payment processor.</p>

          <p>Online donations may be processed through <strong>Stripe</strong>, and refunds may take several business days to appear on the donor's statement.</p>

          <h2 className="font-heading">Contact for Refund Requests</h2>
          <p>
            <strong>Lane 4 For All Kids Foundation</strong><br />
            Email: info@lane4foundation.com<br />
            Phone: 877.495.2634
          </p>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicy;
